import { Routes, Route, Navigate } from 'react-router-dom';
import { Home } from '@/tools/inner-team/pages/Home';
import { ExplorationList } from '@/tools/inner-team/pages/ExplorationList';
import { DiscoveryChat } from '@/tools/inner-team/pages/DiscoveryChat';
import { TeamDashboard } from '@/tools/inner-team/pages/TeamDashboard';
import { TeamMemberDetail } from '@/tools/inner-team/pages/TeamMemberDetail';
import { UserSettings } from '@/apps/app/Settings';
import { MemberConsultChat } from '@/tools/inner-team/pages/MemberConsultChat';
import { TeamConsultChat } from '@/tools/inner-team/pages/TeamConsultChat';
import { ToolHub } from '@/apps/app/Hub/ToolHub';

/**
 * Router for app.teamity.io (End-User-Bereich: Coachees + Self-Signup).
 * Tool-Hub at /, Inner-Team under /inner-team/*, future tools
 * (Journaling, GROW, Ikigai) as placeholder cards in the Hub.
 */
export function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<ToolHub />} />
      <Route path="/einstellungen" element={<UserSettings />} />

      <Route path="/inner-team" element={<Home />} />
      <Route path="/inner-team/entdecken" element={<ExplorationList />} />
      <Route path="/inner-team/entdecken/:id" element={<DiscoveryChat />} />
      <Route path="/inner-team/team" element={<TeamDashboard />} />
      <Route path="/inner-team/team/:id" element={<TeamMemberDetail />} />
      <Route path="/inner-team/konsultation/:id" element={<MemberConsultChat />} />
      <Route path="/inner-team/team-konsultation/:id" element={<TeamConsultChat />} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
